<openpay-header-component></openpay-header-component>
<div>
    <div class="install-wrapper" *ngIf="!loader && !successInstall && !errorSection">
        <div class="install-info">
            <div class="install-openpay-info">
            <p class="tittle-1 text-bolder">Instala Openpay y conecta tu cuenta en Tiendanube</p>
            <table>
                <tr>
                  <td><img src="./assets/img/welcome-assets/welcome-vineta.png" width="30px"></td>
                  <td><p class="regular-text">Recibe los pagos de tu tienda en línea de forma fácil y segura.</p></td>
                </tr>
                <tr></tr>
                <tr></tr>
                <tr></tr>
                <tr>
                  <td><img src="./assets/img/welcome-assets/welcome-vineta.png" width="30px"></td>
                  <td><p class="regular-text">Acepta pagos en efectivo en más de 32,000 puntos de venta.</p></td>
                </tr>
                <tr></tr>
                <tr></tr>
                <tr></tr>
                <tr>
                    <td><img src="./assets/img/welcome-assets/welcome-vineta.png" width="30px"></td>
                    <td><p class="regular-text">Ofrece a tus clientes pagar con mensualidades sin intereses.</p></td>
                  </tr>
                  <tr></tr>
                <tr></tr>
                <tr></tr>
                <tr>
                    <td><img src="./assets/img/welcome-assets/welcome-vineta.png" width="30px"></td>
                    <td><p class="regular-text">Consulta el estado de tus cobros en tiempo real.</p></td>
                  </tr>
              </table>
            </div>
        </div>
        <div class="install-form">
            <div class="install-wrapper-form">
                <p class="tittle-2 text-bolder">Ingresa tus credenciales Openpay</p>
                <p class="regular-text primary-blue text-bolder clickable" (click)="openInfoModal()">Buscar mis credenciales</p>
                <br>
                <div class="input-container">
                    <input type="text" required="" [(ngModel)]="idMerchant" [ngClass]="{'input-container-error': statusSend && idMerchant == ''}"/>
                    <label>ID merchant</label>		
                    <span class="field-info">Está en tu Panel de control, empieza con ID</span> <br>
                    <span class="field-error" *ngIf="statusSend && idMerchant == ''">El ID merchant es requerido</span>
                </div>
                <div class="input-container">
                    <input type="text" required="" [(ngModel)]="privateKey" [ngClass]="{'input-container-error': statusSend && privateKey == ''}"/>
                    <label>Llave privada</label>
                    <span class="field-info">Empieza con sk </span> <br>
                    <span class="field-error" *ngIf="statusSend && privateKey == ''">La llave privada es requerida</span>
                </div>
                <div class="input-container">
                    <input type="text" required="" [(ngModel)]="publicKey" [ngClass]="{'input-container-error': statusSend && publicKey == ''}"/>
                    <label>Llave pública</label>
                    <span class="field-info">Empieza con pk </span> <br>
                    <span class="field-error" *ngIf="statusSend && publicKey == ''">La llave pública es requerida</span>
                </div>
                <div class="install-form-footer">
                    <p class="regular-text">¿Tu negocio aún no tiene Openpay? <br>Puedes <span class="primary-blue text-bolder clickable" (click)="goToRegister()">crear una cuenta gratuita</span></p>
                </div>
                <button class="settings-button clickable" (click)="encryptData()">Ingresar</button>
            </div>
        </div>
    </div>
    <div class="toast-error" *ngIf="errorToast">
        <img src="assets/img/icon-wrong.png" alt="">
        <p>El merchant id o llave privada son <br>incorrectos, intenta de nuevo.</p>
      </div>
</div>

<div class="settings-loader-section" *ngIf="loader">
    <img src="assets/img/Loader.gif" width="300">
    <p style="font-size: 22px; font-weight: bold; margin-top: -70px">Instalando Openpay en tu <br>Tiendanube</p>
    <p style="font-size: 15px; color: #121212;">Por favor no actualices o cierres la pantalla <br> mientras completamos el proceso.</p>
</div>

<div class="settings-error-attempt-section" *ngIf="successInstall">
    <img src="assets/img/Icon-success.png" width="48" height="48">
    <p style="font-size: 22px; font-weight: bold">Instalaste Openpay exitosamente</p>
    <p style="font-size: 15px; color: #121212;">Desde ahora puedes cobrar en tu tienda en línea <br>y explorar tu solución de pago. </p>
    <div>
      <button  class="openpay-primary-button clickable" (click)="backToNuvemshop()">Volver a Tiendanube</button>
    </div>
    <br><br>
    <p>Te redireccionaremos automaticamente a tiendanube en <span class="regular-text primary-blue text-bolder">{{regressiveTime}}s</span></p>
</div>

<div class="settings-error-section" *ngIf="errorSection">
    <img src="assets/img/error-icon/Icon@2x.png" width="48" height="48">
    <p style="font-size: 22px; font-weight: bold">No pudimos guardar los cambios</p>
    <p style="font-size: 15px; color: #121212;">Para poder ayudarte, envía un correo a<b> soporte@openpay.mx</b> </p>
    <button class="openpay-primary-button clickable" (click)="backToNuvemshop()">Volver a Tiendanube</button>
  </div>

  <div class="info-modal" *ngIf="infoModal">
    <div class="modal-dialog">
      <img src="assets/img/communication/info@3x.png" width="24">
      <div class="modal-title">
        <span>Ubica tus credenciales</span>
      </div>
      <div class="modal-text">
        <ul>
            <li><span>Inicia sesión en el Panel de control.</span></li>
            <li><span>Dirígete a la parte superior derecha de la pantalla.</span></li>
            <li><span>Selecciona el ícono de configuración y “Credenciales API”.</span></li>
        </ul>
        <img src="assets/img/searchstep1.png" alt="" width="470">
        <ul>
            <li><span>Encontrarás tus credenciales listas para copiar y pegar.</span></li>
        </ul>
        <img src="assets/img/searchstep2.png" alt="" width="470">
      </div>
      <div class="modal-buttons">
        <button (click)="closeInfoModal()" class="openpay-primary-button clickable">Cerrar</button>
      </div>
    </div>
  </div>
